import React from "react";

import { Button, DetailModal, detailModalDismissButtonProps } from "../ui";

const SaleAddPartModal = ({
    open,
    onClose,
    onSubmit,
    partsItem,
    onPartsFieldChange,
    addingPartsItemError,
}) => {
    return (
        <DetailModal
            open={open}
            onClose={onClose}
            title="Add Part"
            subtitle="Create a new part item for this sale"
            size="md"
            actions={
                <>
                    <Button type="button" {...detailModalDismissButtonProps} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="submit" form="sale-parts-add-form" variant="primary" size="sm">
                        Save part
                    </Button>
                </>
            }
        >
            <p className="detail-section-title" style={{ marginBottom: "0.75rem" }}>
                Part Details
            </p>
            <form
                id="sale-parts-add-form"
                className="Sale-orderform Sale-orderform-modal"
                onSubmit={onSubmit}
            >
                <div className="Sale-order-form-input Sale-order-form-input-date">
                    <label htmlFor="partsListDate">Order Date</label>
                    <input
                        id="partsListDate"
                        name="dateOrdered"
                        type="date"
                        value={partsItem.dateOrdered}
                        onChange={onPartsFieldChange}
                    />
                </div>

                <div className="Sale-order-form-input Sale-order-form-input-qty">
                    <label htmlFor="partsListQuantity">Qty</label>
                    <input
                        id="partsListQuantity"
                        name="quantity"
                        type="number"
                        value={partsItem.quantity}
                        onChange={onPartsFieldChange}
                    />
                </div>

                <div className="Sale-order-form-input" style={{ width: "100%" }}>
                    <label htmlFor="partsListSupplier">Supplier</label>
                    <input
                        id="partsListSupplier"
                        name="supplier"
                        type="text"
                        value={partsItem.supplier}
                        onChange={onPartsFieldChange}
                    />
                </div>

                <div className="Sale-order-form-input" style={{ width: "100%" }}>
                    <label htmlFor="partsListItem">Item</label>
                    <input
                        id="partsListItem"
                        name="item"
                        type="text"
                        placeholder="Item"
                        value={partsItem.item}
                        onChange={onPartsFieldChange}
                    />
                </div>

                <div className="Sale-order-form-input" style={{ width: "100%" }}>
                    <label htmlFor="partsListNote">Note</label>
                    <textarea
                        id="partsListNote"
                        name="note"
                        placeholder="Add Note"
                        value={partsItem.note}
                        onChange={onPartsFieldChange}
                        rows={4}
                    />
                </div>
            </form>
            {addingPartsItemError && (
                <p className="error" style={{ marginTop: "0.75rem" }}>
                    Please fill out quantity before saving.
                </p>
            )}
        </DetailModal>
    );
};

export default SaleAddPartModal;
